import { useQuery, UseQueryResult } from 'react-query'
import { get } from '@fable/api'
import {
  GoalHabitsPeriodType,
  GoalHabitsResponse,
  GoalHabitsType,
} from '../types'
import { useGoalHabits } from '../ctx'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'

export const getGoalHabits = async ({
  userId,
  periodType,
  type,
  year,
}: {
  userId: string
  periodType: GoalHabitsPeriodType
  type: GoalHabitsType
  year: number
}) =>
  await get(
    `/advanced_stats/?user_id=${userId}&period_type=${periodType}&stats_type=${type}&year=${year}`
  )

export const useChartUsery = ({ enabled }: { enabled?: boolean }) => {
  const [type, periodType, setWeekData, setMonthData] = useGoalHabits((s) => [
    s.type,
    s.periodType,
    s.setWeekData,
    s.setMonthData,
  ])
  const [year, userId, yearStatus] = useStats((s) => [
    s.year,
    s.statsUserId,
    s.yearStatus,
  ])
  const queryKey = ['stats-goal-habits', userId, type, periodType, year]

  const query: UseQueryResult<GoalHabitsResponse> = useQuery(
    queryKey,
    () => getGoalHabits({ userId, periodType, type, year }),
    {
      enabled: !!enabled && !!userId && !!periodType,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: ({ data }) =>
        periodType === 'week'
          ? setWeekData({ data, yearStatus, year, goalType: type })
          : setMonthData({ data, yearStatus, goalType: type }),
    }
  )

  return query
}
